import React, {useCallback, useEffect, useMemo} from 'react';
import classes from './CompletedMessage.module.pcss';
import {TabInfo} from 'js/containers/PostTypes/SelfLearning/LearningPath/LearningPath';
import {observer} from 'mobx-react';
import Heading from 'js/components/Common/Heading/Heading';
import parse from 'html-react-parser';
import LearningPathStore from 'js/store/LearningPathStore';
import {useCookies} from 'react-cookie';

interface Props {
    firstTabInfo: TabInfo,
    secondTabInfo: TabInfo,
    pageId: number
}

const CompletedMessage = ({firstTabInfo, secondTabInfo, pageId}: Props) => {
    const [cookies, setCookie] = useCookies([]);
    const tag = LearningPathStore.getTag(pageId, LearningPathStore.activeMainTab);
    const checkedAllInTab1 = LearningPathStore.getGroupCompletedStatus(LearningPathStore.faqStatusList, 1);
    const checkedAllInTab2 = LearningPathStore.getGroupCompletedStatus(LearningPathStore.faqStatusList, 2);
    const {showSecondTabCompleteMessage, showFirstTabCompleteMessage} = LearningPathStore || {};
    const milliseconds = 8000;

    const cookieOption = useMemo(() => (
        {
            path: '/',
            domain: `.${location.hostname}`,
            maxAge: 315360000
        }
    ), []);

    useEffect(() => {
        let timer;
        if (showFirstTabCompleteMessage && checkedAllInTab1) {
            timer = setTimeout(() => {
                LearningPathStore.setShowFirstTabCompleteMessage(false);
            }, milliseconds);
        }

        return () => clearTimeout(timer);
    }, [showFirstTabCompleteMessage, checkedAllInTab1]);

    useEffect(() => {
        let timer;
        if (showSecondTabCompleteMessage && checkedAllInTab2) {
            timer = setTimeout(() => {
                LearningPathStore.setShowSecondTabCompleteMessage(false);
            }, milliseconds);
        }

        return () => clearTimeout(timer);
    }, [showSecondTabCompleteMessage, checkedAllInTab2]);

    const closeCallback = useCallback(() => {
        if (LearningPathStore.activeMainTab === 'first_item') {
            LearningPathStore.setShowFirstTabCompleteMessage(false);
        } else if (LearningPathStore.activeMainTab === 'second_item') {
            LearningPathStore.setShowSecondTabCompleteMessage(false);
        }
        setCookie(tag, true, {...cookieOption});
        return;
    }, [cookieOption, setCookie, tag]);


    if (!cookies[tag] && showFirstTabCompleteMessage && checkedAllInTab1 && LearningPathStore.activeMainTab === 'first_item') {
        return (
            <section className={classes.CompletedMessage}>
                <Heading text={'Congrats!'} type={'h6'}/>
                {parse(firstTabInfo?.completePopup  || '')}
                <span onClick={() => closeCallback()} className={classes.Close} />
            </section>
        );
    }

    if (!cookies[tag] && showSecondTabCompleteMessage && checkedAllInTab2 && LearningPathStore.activeMainTab === 'second_item') {
        return (
            <section className={classes.CompletedMessage}>
                <Heading text={'Congrats!'} type={'h6'}/>
                {parse(secondTabInfo?.completePopup  || '')}
                <span onClick={() => closeCallback()} className={classes.Close} />
            </section>
        );
    }

    return <></>;
};

export default observer(CompletedMessage);
